import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    height: '100%',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    overflow: 'scroll',
  },
  containerInside: {
    maxWidth: '1200px',
    margin: '0px auto',
    marginTop: '20px',
    padding: 10,
    lineHeight: '170%',
  },
  root: {
    flexGrow: 1,
  },
  card: {
    height: '100%',
  },
  cardNumber: {
    fontSize: 40,
  },
  cardNumberSoon: {
    fontSize: 40,
    color: theme.palette.colors.divider,
  },
  expandLess: {
    color: theme.palette.colors.red,
  },
}));



// WEBPACK FOOTER //
// ./src/components/LoanOfficerDashboard/useStyles.js